export const ACTIVE_FEEDBACK = 31;
export const CLOSE_SESSION = 32;
const   SYSTEM_ACTION = 99; // 系统事件

// 人工气泡导航动作类型
export const ACTION_TYPE = {
  ACTION_REPLY: 1, // 系统自动回复
  ACTION_APPLET: 2, // 跳转小程序
  ACTION_VISITOR: 3, // 访客快速发送
  ACTION_WEB: 4, // 跳转网页
  ACTIVE_FEEDBACK,
  CLOSE_SESSION,
  SYSTEM_ACTION,
};

// 人工气泡导航消息类型
export const REPLY_TYPE = {
  REPLY_TXT: 1,
  REPLY_IMG: 2,
  REPLY_IMGTXT: 3,
  REPLY_APPLETPLUGIN: 10,
};

// 机器人气泡导航动作类型
export const ROBOT_REPLY_TYPE = {
  IMGTXT: 1, // 图文消息
  WEB: 2, // 打开URL
  KNOWLEDGE: 6, // 指定知识库问答
  HUMAN: 7, // 转人工
  ACTIVE_FEEDBACK,
  CLOSE_SESSION,
  SYSTEM_ACTION,

};
